<script setup lang="ts">
/**
 * The Japan page Backtest tab — the standalone L&G Japan backtest.
 *
 * It mounts the generic BacktestPanel on L&G Japan alone (asset lg_japan_index, presets in
 * backtest_configs/japan.json, ?fund=japan). Running needs the JAPAN grant; Apply-to-Live is hidden and the
 * server refuses a Japan promote (409), because the active preset drives the live 08:40 threshold.
 *
 * 2026-10-13: the tab's former "Shared pot" mode (whole pot / Japan leg) is retired. It ran a hard-coded
 * table on per-fund preset files that could differ from live; FOF → Backtest replaces it (live table, live
 * presets, over-fit gates, and a per-fund breakdown for any fund).
 *
 * The tab is a superuser tab (fundPages SUPERUSER_TABS); /api/backtest/* is superuser-only, so the
 * standalone panel is too.
 */
import { computed, unref } from 'vue'
import { useAuth } from '../../composables/useAuth'
import BacktestPanel from '../BacktestPanel.vue'

const { isSuperUser } = useAuth()
const superUser = computed(() => unref(isSuperUser) === true)
</script>

<template>
  <div class="japan-bt">
    <p class="jbt-note" data-testid="japan-bt-fof-pointer">
      Whole-pot backtests (all funds together, with each fund's contribution) are in
      <a href="?portfolio=fof#backtest">FOF → Backtest</a>.
    </p>
    <BacktestPanel v-if="superUser" />
  </div>
</template>

<style scoped>
.jbt-note { font-size: 0.75rem; color: #888; line-height: 1.4; margin: 1rem 1rem 0; }
.jbt-note a { color: #4a90d9; }
</style>
